import {IMaskFormatter} from '../../../../shared/directives/mask/IMaskFormatter';

export class FinanceGLAccountMask implements IMaskFormatter {
    public dividers: string[];
    public inputElement: any;
    public placeholder = 'XXXX-XX-XXX-XX-XX';
    static glAccountMask = '****-**-***-**-**';
    public captureCaret;

    // returns the model value restricting it to numbers with slashes(/) appended.
    getModelValue(event, value): string {
        let modelValue = value;
        for (var i = 0; i < this.dividers.length; i++) {
            while (modelValue.indexOf(this.dividers[i]) > -1) {
                modelValue = modelValue.replace(this.dividers[i], '');
            }
        }

        if (modelValue.length !== 0) {
            if (modelValue.match(/^[0-9]*$/)) {   // Accepts only the numbers
                return modelValue;
            } else {
                modelValue = modelValue.toString();  // Removes the non numeric character
                return modelValue.slice(0, -1);
            }
        }

        return modelValue;
    }

    // Jumps the caret poition to the end of the digits.
    setCaretOnClick(model: string): void {
        const caretPos = model.length;
        console.log('caret position', caretPos);
    }

    // Jumps the input caret based on the position. Drives the user to next input location.
    setCaret(model: string, event: any): void {

        let caretPos = model.length;
        if (model.length !== 0) {
            if (model.length >= 4 && model.length <= 5) {
                caretPos = caretPos + 1;
            }

            if (model.length > 5) {
                caretPos = caretPos + 2;
            }

            if (model.length > 6) {
                caretPos = caretPos + 3;
            }

            if (model.length > 8) {
                caretPos = caretPos + 4;
            }

        } else {
            caretPos = 0;
        }

        if (this.inputElement !== null) {
            if (this.inputElement.createTextRange) {
                const range = this.inputElement.createTextRange();
                range.move('character', caretPos);

                range.select();
            } else {
                if (this.inputElement.selectionStart) {
                    this.inputElement.focus();
                    this.inputElement.setSelectionRange(caretPos, caretPos);
                } else {
                    this.inputElement.focus();
                }
            }
        }

        // if (event.which === 8 && model.length === 4) {  // backspace operation escaping the slashes
        //    this.inputElement.setSelectionRange(5, 5);
        // }
        // if (event.which === 8 && model.length === 2) {
        //    this.inputElement.setSelectionRange(2, 2);
        // }
    }

    // transforms to  '  /  /   '
    padString(str: string) {
        const pad = '             ';
        return (str + pad).substring(0, pad.length);
    }

    restrictInput(modelValue: string): boolean {
        if (modelValue) {
            return modelValue.length <= 13;
        }
    }
}
